import React from 'react';

function DetailsHeading() {
  return (
    <div>
      <div className="page-heading header-text">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <span className="breadcrumb">
                <a href="#">Home</a> / Single Property
              </span>
              <h3>Single Property</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailsHeading;
